<template>
  <div class="select-area">
    <div class="show-view"  @click="showOption()" @blur="closeSelect()">
      <div class="select">
        <div class="select-show" :class="{input: hasInput}">{{showText}}</div>
      </div>
      <span class="select-icon">
        <img v-if="selected" class="icon-img" src="../../assets/gangmaster/label-drop-down-selected.png">
        <img v-if="!selected" class="icon-img" src="../../assets/gangmaster/label-drop-down-gray.png">
      </span>
    </div>
    <div class="select-option" :class="{show:optionShow}" @blur="closeSelect()">
      <div class="option-item" v-for="option in options" :class="{selected: selectOption.value == option.value}" @click="updateValue(option)">{{option.text}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'select',
  props: ['label', 'value', 'placeholder', 'name', 'options', 'sort','focus'],
  data () {
    console.info("焦点：",this.focus);
    return {
      isWhite: false,
      selected: typeof this.focus == 'undefined' ? true : this.focus,
      selectOption: this.options[this.value] || {},
      optionShow: false,
      hasInput: (this.value !== '' && this.options[this.value].text),
      showText: (this.value !== '' ? this.options[this.value].text : '') || this.placeholder || ''
    }
  },
  watch:{
    value(val){
      this.selectOption = this.options[val] || {};
      this.showText = (val !== '' ? this.options[val].text : '') || this.placeholder || '';
      this.hasInput = (val !== '' && this.options[val].text);
    }
  },
  methods: {
    updateValue (option) {
      this.$emit('input', option.value);
      this.$emit('changeSelected', option);
      this.selectOption = option;
      this.showText = option.text;
      this.optionShow = false;
      this.hasInput = true;
    },
    showOption(){
        this.optionShow = !this.optionShow;
    },
    closeSelect(){
      this.optionShow = false;
    }
  }
}
</script>
<style lang="scss">
  .select-area{
    /*height: 0.88rem;*/
    height: 100%;
    position: relative;
    /*padding-left: 0.33rem;*/
    padding-right: 0.11rem;
    border-radius: 0.06rem;
    display: flex;
    align-items: center;
    .show-view{
      width: 100%;
      position: relative;
      display: flex;
      z-index: 0;
      .select-title{
        /*line-height: 0.88rem;*/
        padding-right: 0.28rem;
        flex-shrink: 0;
        z-index: 112;
      }
      .select{
        /*height: 0.88rem;*/
        height: 100%;
        position: relative;
        flex-grow: 1;
        .select-show{
          color: #878E99;
          /*height: 0.88rem;*/
          height: 100%;
          /*line-height: 0.88rem;*/
          &.input{
            color: #878E99;
          }
        }
      }
      .select-icon{
        height: 100%;
        margin-top: 0.08rem;
        padding-left: 0.2rem;
        flex-shrink: 0;
        .icon-img{
          width: 0.2rem;
          height: 0.18rem;
        }
      }
    }
    .select-option{
      width: 100%;
      position: absolute;
      top:100%;
      left: 0;
      max-height: 4.3rem;
      overflow: scroll;
      margin-top:0px;
      background-color: #F3F8FC;
      display: none;
      z-index: 113;
      &.show{
        display: block;
      }
      .option-item{
        overflow: hidden;
        height: 0.88rem;
        line-height: 0.88rem;
        text-align: center;
        z-index: 114;
        color:  #878E99;
        &.selected{
          color: #1D8AE7;
        }
        &:hover{
          background-color: #1D8AE7;
          color: white;
        }
      }
    }
  }
</style>
